<template>
  <div class="list-actions-ref" v-show="listActionsVal !== 0">
    <v-row class="mt-n5" dense v-show="listActionsVal === 5">
      <!-- <v-col cols="4">
        <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
         :criteriaState="editedItem" />
      </v-col> -->
      <v-col cols="4">
        <CommonDropDowns :isItTaxFee="true" :taxFeeRequired="true" @change="dataFromCommonDropDowns"
        :taxFeeNumValue="editedItem.feeNumber" />
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0 mt-4" label="Fee Amount"
        v-model="editedItem.feeAmount" :rules="rules"
        @blur="roundAmount" @focus="amountToNum(), $event.target.select()" />
      </v-col>
      <v-col cols="4">
        <ClarionDateControl class="input-text-size pa-0" label="Effective Date"
         :isRequired="false" v-model="editedItem.effectiveDate" :isToggle="false" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { amountFormat, amountToNumber } from '../../../../../util/shared/vue-global';
import CommonDropDowns from '../../../common-utils/CommonDropDowns.mixin.vue';
import '../../../../../assets/style.css';

export default {
  name: 'ResaleListActionList',
  components: {
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    listActionsVal: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item', 'criteria']),
    ...mapState({
      latestSaleYear: (state) => state.tax.juneResale.latestSaleYear,
      saleYearList: (state) => state.tax.juneResale.saleYearList,
      isVisibleResaleList: (state) => state.base.crud.isVisible.ResalePropertyList,
    }),
    rules() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    editedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions('tax/juneResale', [
      'loadJuneResale',
      'deleteJuneResale',
    ]),
    roundAmount() {
      this.editedItem.feeAmount = amountFormat(amountToNumber(this.editedItem.feeAmount));
    },
    amountToNum() {
      this.editedItem.feeAmount = amountToNumber(this.editedItem.feeAmount);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
  },
};
</script>
